import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { LoggedInUserService } from '@vectronic/shared/data-access/logged-in-user';

export const hasRole: CanMatchFn = (route) =>
  route.data['requiredRoles'].some((role: string) =>
    inject(LoggedInUserService).roles().includes(role),
  );

export const isAuthenticated: CanMatchFn = () => inject(LoggedInUserService).isAuthenticated();
